(function(){
  function setupSizeGuides(root){
    var scope=root||document;
    scope.querySelectorAll('[data-weskara-size-open]').forEach(function(opener){
      if(opener.dataset.weskaraReady==='true')return;
      opener.dataset.weskaraReady='true';
      var dialog=opener.parentElement?opener.parentElement.nextElementSibling:null;
      if(!dialog||!dialog.matches('[data-weskara-size-dialog]'))dialog=document.querySelector('[data-weskara-size-dialog]');
      if(!dialog)return;
      var closeButton=dialog.querySelector('[data-weskara-size-close]');
      opener.addEventListener('click',function(){
        if(typeof dialog.showModal==='function')dialog.showModal();
        else dialog.setAttribute('open','');
      });
      if(closeButton)closeButton.addEventListener('click',function(){
        if(typeof dialog.close==='function')dialog.close();
        else dialog.removeAttribute('open');
      });
      dialog.addEventListener('click',function(event){
        if(event.target!==dialog)return;
        var rect=dialog.getBoundingClientRect();
        var inside=event.clientX>=rect.left&&event.clientX<=rect.right&&event.clientY>=rect.top&&event.clientY<=rect.bottom;
        if(!inside){
          if(typeof dialog.close==='function')dialog.close();
          else dialog.removeAttribute('open');
        }
      });
    });
  }

  function setupStickyAtc(){
    var bar=document.querySelector('[data-weskara-sticky-atc]');
    if(!bar||bar.dataset.weskaraReady==='true')return;
    bar.dataset.weskaraReady='true';
    var stickyButton=bar.querySelector('[data-weskara-sticky-button]');
    var priceNode=bar.querySelector('.weskara-sticky-atc__price');
    var observer=null,ticking=false;
    function getProductInfo(){return document.querySelector('product-info[id^="MainProduct-"]')||document.querySelector('product-info');}
    function getMainButton(){var info=getProductInfo();return info?info.querySelector('.product-form__submit'):null;}
    function getVisiblePrice(info){
      if(!info)return null;
      var items=Array.prototype.slice.call(info.querySelectorAll('.price-item'));
      for(var i=0;i<items.length;i++){
        var item=items[i];
        if(item&&!item.closest('s')&&item.offsetParent!==null&&item.textContent.trim())return item.textContent.replace(/\s+/g,' ').trim();
      }
      return null;
    }
    function sync(){
      var info=getProductInfo(),mainButton=getMainButton();
      if(priceNode&&info){var p=getVisiblePrice(info);if(p)priceNode.textContent=p;}
      if(stickyButton&&mainButton){
        var label=mainButton.textContent.replace(/\s+/g,' ').trim()||'Add to cart';
        stickyButton.textContent=label;
        var disabled=mainButton.disabled||mainButton.getAttribute('aria-disabled')==='true';
        stickyButton.disabled=disabled;
        stickyButton.setAttribute('aria-disabled',disabled?'true':'false');
      }
    }
    function updateVisibility(){
      var mainButton=getMainButton();
      var shouldShow=window.innerWidth<=749&&mainButton&&mainButton.getBoundingClientRect().bottom<0;
      bar.classList.toggle('is-visible',Boolean(shouldShow));
      bar.setAttribute('aria-hidden',shouldShow?'false':'true');
    }
    function requestUpdate(){
      if(ticking)return;
      ticking=true;
      window.requestAnimationFrame(function(){sync();updateVisibility();ticking=false;});
    }
    if(stickyButton)stickyButton.addEventListener('click',function(){
      var info=getProductInfo(),mainButton=getMainButton();
      if(!mainButton)return;
      var disabled=mainButton.disabled||mainButton.getAttribute('aria-disabled')==='true';
      if(disabled){
        var variantControl=info?info.querySelector('variant-selects, variant-radios, .product-form__input'):null;
        if(variantControl)variantControl.scrollIntoView({behavior:'smooth',block:'center'});
        return;
      }
      mainButton.click();
    });
    function connectObserver(){
      if(observer)observer.disconnect();
      var info=getProductInfo();
      if(!info)return;
      observer=new MutationObserver(requestUpdate);
      observer.observe(info,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','disabled','aria-disabled']});
    }
    window.addEventListener('scroll',requestUpdate,{passive:true});
    window.addEventListener('resize',requestUpdate);
    document.addEventListener('change',function(){window.setTimeout(function(){connectObserver();requestUpdate();},50);});
    connectObserver();
    requestUpdate();
  }

  function setupStoreReviewsDefault(){
    if(document.documentElement.dataset.weskaraStoreReviewsDefault==='true')return;
    document.documentElement.dataset.weskaraStoreReviewsDefault='true';
    var done=false;
    var timer=null;
    var observer=null;

    function activateStoreReviews(){
      if(done)return true;
      var root=document.querySelector('#judgeme_product_reviews');
      if(!root)return false;
      var nodes=root.querySelectorAll('button,a,[role="tab"]');
      for(var i=0;i<nodes.length;i++){
        var text=(nodes[i].textContent||'').replace(/\s+/g,' ').trim();
        if(/store reviews?/i.test(text)||/store ratings?/i.test(text)){
          var alreadySelected=nodes[i].getAttribute('aria-selected')==='true'||nodes[i].classList.contains('active')||nodes[i].classList.contains('jdgm-tab__tab--active');
          if(!alreadySelected)nodes[i].click();
          done=true;
          if(timer)window.clearInterval(timer);
          if(observer)observer.disconnect();
          return true;
        }
      }
      return false;
    }

    var tries=0;
    timer=window.setInterval(function(){
      tries++;
      if(activateStoreReviews()||tries>48)window.clearInterval(timer);
    },250);

    observer=new MutationObserver(function(){activateStoreReviews();});
    observer.observe(document.documentElement,{childList:true,subtree:true});
    window.setTimeout(function(){
      if(observer)observer.disconnect();
      if(timer)window.clearInterval(timer);
    },12000);
  }

  function init(root){
    setupSizeGuides(root||document);
    setupStickyAtc();
    setupStoreReviewsDefault();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});
  else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target||document);});
})();